<div class="element {{type}}" id="{{uid}}" #chart></div>
